import axios from 'axios'
import { message } from 'antd'

axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true
axios.defaults.timeout = 30000

if (process.env.NODE_ENV === 'production') {
  axios.interceptors.response.use(function (response) {
    let redirectUrl = response.headers.oppo_redirect_url || response.headers.OPPO_REDIRECT_URL
    if (redirectUrl) {
      // window.location.href=redirectUrl.replace(/\?callback=.*$/,'?callback='+encodeURI(window.location.href))
      window.location.href = redirectUrl
      // throw new axios.Cancel('redirect')
    }
    return response
  })
}

function post(url, data, headers) {
  return httpWithToken('POST', url, data, headers)
}

function get(url, data, headers) {
  return httpWithToken('GET', url, data, headers)
}

function httpWithToken(method, url, data, headers = {}) {
  let token = sessionStorage.getItem('lockcard_token')
  if (token) {
    headers = Object.assign(headers, { TOKEN: token })
  }
  return http(method, url, data, headers)
}

function http(method = 'GET', url, data, headers = {}) {
  if (process.env.NODE_ENV === 'development') {
    url = `https://test-in-lockcard.myoas.net` + url
  }
  let config = method === 'GET' ? {
    method: method,
    url: url,
    params: data,
    headers: headers
  } : {
      method: method,
      url: url,
      data: data,
      headers: headers
    }
  return new Promise((resolve, reject) => {
    axios(config).then((res) => {
      if (res && res.status === 200) {
        // 错误处理
        if (res.data.code && res.data.code !== 200) {
          switch (url) {
            case '/api/user/getToken':
              break
            case '/api/user/getUserInfo':
              if (res.data.code === 1 && res.data.data) {
                window.location.href = res.data.data
              }
              break
            default:
              message.error(res.data.info || res.data.message)
              break
          }
        }
        resolve(res.data)
      } else {
        reject(res && res.data)
      }
    }).catch((err) => {
      message.error(err.toString())
      reject(err)
    })
  })
}

export default {
  get,
  post
}